// extracted by mini-css-extract-plugin
module.exports = {"modal":"index-module--modal--2gJqx"};